var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Modal, useModal } from '../modal';
import { headerStyle } from './styles';
function Header(_a) {
    var children = _a.children, _b = _a.mode, mode = _b === void 0 ? 'plain' : _b, restProps = __rest(_a, ["children", "mode"]);
    var alignCenter = useModal().alignCenter;
    return (_jsx(Modal.Header, __assign({ css: headerStyle({ alignCenter: alignCenter, mode: mode }), mode: mode }, restProps, { children: children })));
}
export default Header;
